import { MsoLocationReport } from './../model/mso-location-report';
import { MonthlyExceptionsReports } from './../model/monthly-exceptions-reports';
import { ExceptionReportCCDto } from './../model/exception-report-cc-dto';
import { PurchaseOrderReportDto } from './../model/purchase-order-report-dto';
import { MonthlyExceptionReportM2m } from './../model/monthly-exception-report-m2m';
import { HttpclientService } from 'src/app/services/httpclient.service';
import { UnprocessedPoReportDto } from './../model/unprocessed-po-report-dto';
import { PBJReportDto } from './../model/pbjreport-dto';
import { Purchaseorderdto } from './../model/purchageorderdto';
import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import * as jsPDF from 'jspdf';
import 'jspdf-autotable';
import { DatePipe } from '@angular/common';
import { AppSettingService } from './app-setting.service';
import { MonthlyLocationDto } from '../model/monthly-location-dto';
import { ExceptionReportDto } from '../model/exception-report-dto';
import { EdiEdpar } from '../model/ediEdpar';
import { EdiMatlConv } from '../model/ediMatlConv';
import { EdiDunsMaster } from '../model/ediDunsMaster';
import { DomSanitizer } from '@angular/platform-browser';
import { OrderInterfaceLogFileDto } from '../model/order-interface-log-file-dto';
import { StoreConvert } from '../model/StoreConvert';
import { BOLReportDTO } from '../model/bol-report-dto';
import { POLineItemDetailReportDTO } from '../model/po-line-item-detail-report-dto';


@Injectable({
  providedIn: 'root'
})
export class FileExportService {

  public selectedPoData: Purchaseorderdto[] = [];
  public selectedMonthLocationReportData: MonthlyLocationDto[] = [];
  public selectedMsoLocationReportData: MsoLocationReport[] = [];
  public selectedUnprocessedPoReportData: UnprocessedPoReportDto[] = [];
  public selectedPbjReportData: PBJReportDto[] = [];
  public selectedMonthlyExceptionsReportM2MData: ExceptionReportDto[] = [];
  public selectedMonthlyExceptionsReportM2MData1: MonthlyExceptionReportM2m[] = [];
  public selectedMonthlyExceptionsReportsData: MonthlyExceptionsReports[] = [];
  public selectedMonthlyExceptionsReportCcData: ExceptionReportDto[] = [];
  public selectedMonthlyExceptionsReportCcData1: ExceptionReportCCDto[] = [];
  public selectedEdiEdparData: EdiEdpar[] = [];
  public selectedEdiMatlConvData: EdiMatlConv[] = [];
  public selectedEdiDunsMasterData: EdiDunsMaster[] =[];
  public selectedStoreConvertData: StoreConvert[] =[];
  public selectedPurchaseOrderReportData: PurchaseOrderReportDto[] = [];
  public selectedBOLReportData: BOLReportDTO[] = [];
  public selectedPOLineItemDetailReportData: POLineItemDetailReportDTO[] = [];
  
  constructor(private datePipe: DatePipe, public appSettingService: AppSettingService, private sanitizer: DomSanitizer,
              public httpclientService: HttpclientService ) { }

  fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  fileExtension = '.xlsx';
  fileUrl;

  public exportExcel(jsonData: any[], fileName: string): void {

    

    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(jsonData);
    const wb: XLSX.WorkBook = { Sheets: { 'data': ws }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    this.saveExcelFile(excelBuffer, fileName);
  }

  private saveExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {type: this.fileType});
    FileSaver.saveAs(data, fileName + this.fileExtension);
  }


  public saveXmlFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {type: this.fileType});
    FileSaver.saveAs(data, fileName + '.xml');
  }

public downloadXmlFile(contentData) {
  const data = contentData;
  const blob = new Blob([data], { type: 'application/octet-stream' });

  return this.fileUrl = this.sanitizer.bypassSecurityTrustResourceUrl(window.URL.createObjectURL(blob));
  }









  


//// PDF Export



exportPoPdfAll(fileName, poDataList) {

  const doc = new jsPDF('l', 'pt', 'a4');
  // const col = ['OrderDate', 'PONo', 'BOLNo', 'InvoiceNo', 'Customer', 'Distributor' , 'SoldTo' , 'Status', 'Type'];
 const col = ['Order Date', 'Status', 'Customer', 'PO No.', 'Type', 'Sold To' , 'Distributor' , 'BoL No.', 'Invoice No.'];
  // tslint:disable-next-line:prefer-const
  let rows = [];
  poDataList.forEach(pdto => {
  let  poType: any, orderDate: any;
  if (pdto.poType === 'PO') {
    poType = 'Standard';
     } else {
      poType = 'Return';
     }
  orderDate = this.datePipe.transform(pdto.poReceivedDateTime, this.appSettingService.globelDateFormat);

  // const temp = [orderDate, pdto.purchaseOrderNumber, pdto.supplierDocReferenceNumber,
  //          pdto.billDocNumber, pdto.customerName2,
  //           pdto.supplierSoldToId, pdto.customerSoldToID , pdto.purchaseOrderQuantityStatusCodeID, poType];
  const temp = [orderDate, pdto.purchaseOrderQuantityStatusCodeID, pdto.customerName2,
    pdto.purchaseOrderNumber, poType,
     pdto.customerSoldToID, pdto.supplierSoldToId , pdto.supplierDocReferenceNumber, pdto.billDocNumber];
  rows.push(temp);
    
      });

 // doc.autoTable(col, rows);
  doc.autoTable(col, rows , {

    startY: 40,
    margin: {
        top: 40
    },
    styles: {
      fontSize: 5,
      overflow: 'linebreak',
      columnWidth: 'wrap',
  },
    
    headStyles:{
      valign: 'middle',
      halign : 'left'
    },
    // startY: 15,
    /* apply styling to table body */
   
    /* apply global styling */
    // styles: {
    //     cellWidth: 'wrap',
    //     rowPageBreak: 'auto',
    //     halign: 'justify'
    // },
    /* apply styling specific to table columns */
    columnStyles: {
      0: {cellWidth: 70},
      1: {cellWidth: 60},
      2: {cellWidth: 80},
      3: {cellWidth: 100},
      4: {cellWidth: 60},
      5: {cellWidth: 80},
      6: {cellWidth: 100},
      7: {cellWidth: 120},
      8: {cellWidth: 90}
  },
    theme: 'grid'    
});

  doc.save(fileName + '.pdf');
}

exportPoPdf(fileName) {

  const doc = new jsPDF('l', 'pt', 'a4');
  // const col = ['OrderDate', 'PONo', 'BOLNo', 'InvoiceNo', 'Customer', 'Distributor' , 'SoldTo' , 'Status', 'Type'];
  const col = ['Order Date', 'Status', 'Customer', 'PO No.', 'Type', 'Sold To' , 'Distributor' , 'BoL No.', 'Invoice No.'];
  // tslint:disable-next-line:prefer-const
  let rows = [];
  this.selectedPoData.forEach(pdto => {
    if (pdto.rowCheck) {
  let  poType: any, orderDate: any;
  if (pdto.poType === 'PO') {
    poType = 'Standard';
     } else {
      poType = 'Return';
     }
  orderDate = this.datePipe.transform(pdto.poReceivedDateTime, this.appSettingService.globelDateFormat);

  // const temp = [orderDate, pdto.purchaseOrderNumber, pdto.supplierDocReferenceNumber,
  //          pdto.billDocNumber, pdto.customerName2,
  //           pdto.supplierSoldToId, pdto.customerSoldToID , pdto.purchaseOrderQuantityStatusCodeID, poType];
  const temp = [orderDate, pdto.purchaseOrderQuantityStatusCodeID, pdto.customerName2,
    pdto.purchaseOrderNumber, poType,
     pdto.customerSoldToID, pdto.supplierSoldToId , pdto.supplierDocReferenceNumber, pdto.billDocNumber];
  rows.push(temp);
    }
      });

 // doc.autoTable(col, rows);
  doc.autoTable(col, rows , {

    startY: 40,
    margin: {
        top: 40
    },

    styles: {
        fontSize: 5,
        overflow: 'linebreak',
        columnWidth: 'wrap',
    },
    headStyles:{
      valign: 'middle',
      halign : 'left'
    },
    // startY: 15,
    /* apply styling to table body */
   
    /* apply global styling */
    // styles: {
    //     cellWidth: 'wrap',
    //     rowPageBreak: 'auto',
    //     halign: 'justify'
    // },
    /* apply styling specific to table columns */
    columnStyles: {
      0: {cellWidth: 70},
      1: {cellWidth: 60},
      2: {cellWidth: 80},
      3: {cellWidth: 100},
      4: {cellWidth: 60},
      5: {cellWidth: 80},
      6: {cellWidth: 100},
      7: {cellWidth: 120},
      8: {cellWidth: 90}
  },
    theme: 'grid'   
});

  doc.save(fileName + '.pdf');
}

downloadXml(data){
  const blob = new Blob([data.isSaved], { type: 'application/xml' });
  this.fileUrl = this.sanitizer.bypassSecurityTrustResourceUrl(window.URL.createObjectURL(blob));
}


}
